export class ModulesSubmodulesPermissionsByRole {
    id: number ;
    roleId: number = null;
    tenantId:number = null;
    moduleId: number = null;
    subModuleId: number = null;
    permissionIds: string = null;
    status: number = null;
    // tslint:disable-next-line:no-inferrable-types
    isDeleted: boolean = false;
    updateCount: number = 1;
    createdBy: string = null;
    createDate: Date = new Date();
    updatedBy: string = null;
    updateDate: Date = new Date();
}
